import { UserAccess } from "components/user-access";
import { ManualEntryTemplateListing } from "pages/manual-entry-templates/listing";
import { PageRestricted } from "pages/errors/page-restricted";
import React, { useEffect, useState } from "react";
import { Breadcrumbs } from "components/navigation/Breadcrumbs";
import { useNavigate, useParams } from "react-router-dom";

export function ManualEntryTemplates() {
    const { from, id } = useParams();
    var navigate = useNavigate();

    const defaultBreadcrumbs = [{ location: "/", title: "Home" }, { title: "Manage Templates" }];
    const driversBreadcrumbs = [{ location: `${globalThis.env.VISION_URL}/#`, title: "Home", externalLink: true }, { location: `${globalThis.env.VISION_URL}/#/Drivers/`, title: "Manage My Employees", externalLink: true }, { title: "Manage Templates" }];
    const [breadcrumbs, setBreadcrumbs] = useState(defaultBreadcrumbs);

    useEffect(() => {
        if (from == null) {
            return;
        }

        if (from === "drivers") {
            setBreadcrumbs(driversBreadcrumbs);
        }
        else if (from === "calendar") {
            setBreadcrumbs([
                {...driversBreadcrumbs[0]},
                {...driversBreadcrumbs[1]},
                ...(id ? [{ location: `${window.env.VISION_URL}/#/Drivers/RedirectToCalendar?driverId=${id}&`, title: "Employee Calendar", externalLink: true }] : []),
                {...driversBreadcrumbs[2]}
            ])
        }

        navigate("/manual-entry-templates", { replace: true });
    }, [from, id]);
    
    return (
        <UserAccess perform={"Employees:AddManualEntry"}
            yes={() => (
                <div className="row">
                    <Breadcrumbs items={breadcrumbs} />
                    <ManualEntryTemplateListing />
                </div>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}